import * as React from "react";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { SortModel } from "components/data/DataSource";
import { WebApiDataSource } from "components/data/WebApiDataSource";
import * as API from "common/api/Evidence/Clenove/DetailClena";
import DataGrid, { Column, DataGridProps } from "components/controls/DataGrid";
import PageContent from "common/web/PageContent";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    data: API.VyslSoutClena[];
}

interface VysledkySouteziProps {
    idtClena: number;
    clenId: number;
    lang: string;
}

type PropsType = VysledkySouteziProps & State & ActionsExecutorPropsType;


const initialState: State = {
    loading: true,
    hasError: false,
    data: [],
}


class VysledkySoutezi extends React.PureComponent<PropsType> {

    private dataSource: WebApiDataSource<API.VyslSoutClena>;
    private columns: Column<API.VyslSoutClena>[];

    constructor(props: PropsType) {
        super(props);

        this.dataSource = new WebApiDataSource(this.getDataAction);
        this.dataSource.setPageSize(20, true);

        const sortedItems: { [index: string]: SortModel } = {
            ['Datum']: { field: 'Datum', direction: 'desc' }
        }

        this.dataSource.setSortedItems(sortedItems);

        this.columns = [
            { headerText: "Datum", field: "Datum", width: 100, type: 'date', format: 'DD.MM.YYYY' },
            { headerText: "Název soutěže", field: "Nazev" },
            { headerText: "Místo", field: "Misto" },
            { headerText: "Kategorie", field: "Kategorie", render: this.renderKategorie },
            { headerText: "Umístění", field: "Umisteni", width: 90, render: this.renderUmisteni },
        ];

        /*
         Datum: Date;
            Nazev: string;
            Misto: string;
            Kategorie: string;
            PoradiOd: number;
            PoradiDo: number;
            PartnerIdt?: number;
        */
    }

    renderKategorie = (col: Column<API.VyslSoutClena>, row: API.VyslSoutClena) => {
        const { lang } = this.props;
        const link = '../../../../../../../' + lang + '/VysledkySoutezi/Soutez/' + row.Id;
        return <a href={link} target="_blank">{row.Kategorie}</a>
    }

    renderUmisteni = (col: Column<API.VyslSoutClena>, row: API.VyslSoutClena) => {
        if (row.PoradiOd < row.PoradiDo)
            return row.PoradiOd + '. - ' + row.PoradiDo + '.';
        else
            return row.PoradiOd + '.';
    }

    getDataAction = () => {
        return API.GetVysledkySoutezi(this.props.idtClena);
    }

    /*
        load = () => {
            const { executeAction, updateState, idtClena } = this.props;
            const action = API.GetVysledkySoutezi(idtClena)
                .onSuccess(d => {
                    updateState({ loading: false, data: d });
                })
                .onError(e => {
                    const errMessage = e.message;
                    updateState({ loading: false, hasError: true, error: errMessage });
                });
    
            executeAction(action, { loading: true, hasError: false });
        }
        componentWillMount() {
            this.load();
        }
        */
    render() {

        const dgProps: DataGridProps<API.VyslSoutClena> = {
            dataSource: this.dataSource,
            columns: this.columns,
            //  query: this.query,
            paginationSettings: {
                pageCount: 5,
                //allowItemsCountInfo: true,
                autoHide: true,
            },
            allowPaging: true,
            //allowResizing: true,
            //allowSorting: true,
            //height: 'grow',
            // height: 300,
            // autoFitColumns:[]

            padding: 'dense',
            //            gridLines: 'horizontal',
            showBorder: false,
        }



        return <PageContent titles={['Soutěžní údaje', 'Výsledky soutěží']}>
            <DataGrid {...dgProps} />
        </PageContent>;
    }
}

export default withActionsExecutor<VysledkySouteziProps, State>(initialState, VysledkySoutezi);
